/*
 * Copyright 2020 AlexaCRM
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy of this software and
 * associated documentation files (the "Software"), to deal in the Software without restriction, including
 * without limitation the rights to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is furnished to do so,
 * subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR IMPLIED,
 * INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY, FITNESS FOR A PARTICULAR
 * PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS
 * BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT,
 * TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE
 * OR OTHER DEALINGS IN THE SOFTWARE.
 */

import axios from 'axios'
import isObject from 'lodash/isObject'

const defaults = window.icdsAPIDefaults

const NS_V1 = 'integration-cds/v1'
const NS_V2 = 'integration-cds/v2'

function Api(namespace) {
  let baseUrl = defaults.endpointBaseUrl
  if(baseUrl.substr(-1) === '/') {
    baseUrl = baseUrl.substr(0, baseUrl.length - 1)
  }

  let client = axios.create({
    baseURL: [baseUrl, namespace || NS_V1].join('/'),
    withCredentials: true,
    headers: {
      'Content-Type': 'application/json',
      'X-WP-Nonce': defaults.nonce,
    },
    responseType: 'json',
  })

  client.interceptors.response.use((resp) => resp, error => {
    return Promise.reject(new ApiError(error))
  })

  return client
}

class ApiError {
  constructor(axiosError) {
    this.originalError = axiosError

    if(axiosError.response) {
      let resp = axiosError.response.data
      if(!isObject(resp)) {
        resp = {}
      }

      this.httpStatus = axiosError.response.status
      this.code = resp.code
      this.message = resp.message
      this.data = resp.data
    } else {
      this.message = axiosError.message
    }

    const reqMethod = axiosError.config.method + ''
    if(this.httpStatus === 405 && !this.message) {
      this.message = `HTTP ${reqMethod.toUpperCase()} forbidden by the web server. Please check configuration.`
    } else if(!this.message) {
      const url = axiosError.config.url
      this.message = `Unknown error (${this.httpStatus} / ${reqMethod.toUpperCase()} "${url}")`
    }
  }
}

export const Api2 = () => Api(NS_V2)
export default Api
